import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export const EvChart = ({ legs, color }) => {
  let p = 1, dec = 1;
  const data = [{ leg: 0, prob: 100, payout: 0 }, ...legs.map((l, i) => {
    p *= l.true_prob;
    dec *= l.decimal;
    return { leg: i + 1, prob: +(p * 100).toFixed(1), payout: +((dec - 1) * 100).toFixed(0) };
  })];
  return (
    <div className="px-5 pt-3 pb-1" data-testid="ev-chart">
      <p className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">Risk curve · $100 stake</p>
      <ResponsiveContainer width="100%" height={110}>
        <AreaChart data={data} margin={{ top: 4, right: 0, left: -14, bottom: 0 }}>
          <defs>
            <linearGradient id="probGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.35} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="leg" tick={{ fill: "#64748B", fontSize: 10 }} tickLine={false} axisLine={{ stroke: "#1F1F26" }}
            label={{ value: "legs", position: "insideBottomRight", fill: "#475569", fontSize: 9, dy: 4 }} />
          <YAxis yAxisId="prob" tick={{ fill: "#64748B", fontSize: 10 }} tickLine={false} axisLine={false} unit="%" domain={[0, 100]} />
          <YAxis yAxisId="payout" orientation="right" hide />
          <Tooltip
            contentStyle={{ background: "#1F1F26", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, fontSize: 12 }}
            labelFormatter={(v) => `${v} leg${v === 1 ? "" : "s"}`}
            formatter={(val, name) => name === "prob" ? [`${val}%`, "Hit probability"] : [`+$${val}`, "Profit"]} />
          <Area yAxisId="prob" type="monotone" dataKey="prob" stroke={color} strokeWidth={2} fill="url(#probGrad)" />
          <Area yAxisId="payout" type="monotone" dataKey="payout" stroke="#94A3B8" strokeWidth={1.5} strokeDasharray="4 3" fill="none" />
        </AreaChart>
      </ResponsiveContainer>
      <div className="flex gap-4 text-[10px] text-slate-500 mt-1">
        <span className="flex items-center gap-1"><span className="h-0.5 w-4 rounded" style={{ background: color }} /> Hit probability</span>
        <span className="flex items-center gap-1"><span className="h-0.5 w-4 rounded bg-slate-400" style={{ borderTop: "1px dashed" }} /> Profit on $100</span>
      </div>
    </div>
  );
};
